/*global ncolCheckout*/

/**
 * NCOL Checkout/Payments Form integration.
 * @param {object} form - the form item.
 * @returns early if no payment fieldsets found.
 */
function initNCOLCheckout(form) {
	const fieldsets = form.element.querySelectorAll('[data-ncol-checkout]');
	if (!fieldsets || fieldsets.length < 1) return;

	fieldsets.forEach(function(fieldset) {
		// Check if ncolCheckout is loaded from external source.
		if (!window.ncolCheckout) {
			fieldset.textContent = '';
			form.fieldFeedback.set(
				fieldset.dataset.ncolCheckout,
				'error',
				'Something went wrong on our end. Please try again in a few minutes.'
			);
			return console.error('[Form] ncolCheckout.js not available.');
		}

		// Get and check if API key and App code are available.
		const apiKey = fieldset.dataset.checkoutApiKey;
		const app = fieldset.dataset.checkoutProduct;
		const domain = fieldset.dataset.checkoutDomain;
		if (!apiKey || !app) {
			fieldset.textContent = '';
			form.fieldFeedback.set(
				fieldset.dataset.ncolCheckout,
				'error',
				'Something went wrong on our end. Please try again in a few minutes.'
			);
			return console.error('[Form / NCOL Checkout] API Key and/or App not set.');
		}

		// Setup the checkout.
		const checkout = ncolCheckout({ app, apiKey, domain });
		checkout.createInputs(fieldset.id);

		/**
		 * Process payment during pre-submission task.
		 * @returns {boolean} true when ready to submit form.
		 */
		const paymentProcess = async () => {
			// Check checkout status before submitting.
			if (await checkout.submit()) return true;
			else {
				form.fieldFeedback.set(
					fieldset.dataset.ncolCheckout,
					'error',
					checkout.getFeedbackMessage().message
				);
				return false;
			}
		};

		// Add paymentProcess function to preSubmit stack.
		form.preSubmit.push(paymentProcess);
	});
}

export default initNCOLCheckout;